module.exports = __webpack_public_path__ + "1792771649312/fonts/Urbanist-Regular.837b192.ttf";